import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  Output,
  TemplateRef,
} from '@angular/core';
import { IconRegistryService } from '@rd/core/services/icon-registry/icon-registry.service';
import { ButtonTheme } from '@rd/types/button-theme.type';
import { DialogRef } from '../../dialog-ref';

export type HtmlButtonType = 'button' | 'reset' | 'submit';

@Component({
  selector: 'rd-popup-default-template',
  templateUrl: './default-template.component.html',
  styleUrls: ['./default-template.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogDefaultTemplateComponent {
  @HostBinding('class.rd-popup-default-template') componentClass = true;

  @Input() title?: string;
  @Input() dialogContent: TemplateRef<any>;
  // buttons
  @Input() showButtons? = false;

  // primary button
  @Input() primaryButtonFullWidth? = false;
  @Input() primaryButtonAriaLabel: string;
  @Input() primaryButtonText: string;
  @Input() primaryButtonClass = '';
  @Input() primaryButtonIsDisabled = false;
  @Input() primaryButtonTheme?: ButtonTheme = 'primary';
  // TODO: apply this property once rd-shared-button support pass custom button type
  @Input() primaryButtonType?: HtmlButtonType = 'button';
  @Output() primaryButtonClick = new EventEmitter();

  // secondary button
  @Input() showSecondaryButton? = false;
  @Input() secondaryButtonText? = '';
  @Input() secondaryButtonClass = '';
  @Input() secondaryButtonIsDisabled = false;
  @Input() secondaryButtonTheme?: ButtonTheme = 'secondary';
  // TODO: apply this property once rd-shared-button support pass custom button type
  @Input() secondaryButtonType?: HtmlButtonType = 'button';
  @Output() secondaryButtonClick = new EventEmitter();

  // close button
  @Input() showCloseButton = true;
  @Input() onClose = new EventEmitter();
  @Input() closeDialogOnCloseButtonClick? = true;

  constructor(
    private dialogRef: DialogRef,
    private iconRegistryService: IconRegistryService,
  ) {
    this.registerIcons();
  }

  private registerIcons(): void {
    this.iconRegistryService.registerIcon('close');
  }

  onRequestClose(): void {
    this.onClose.emit();
    // allow parent component control when to close the popup
    // this feature is useful when we want to prompt user about form unsaved changes
    if (!this.closeDialogOnCloseButtonClick) {
      return;
    }
    this.dialogRef.close();
  }

  onPrimaryClickEmit(): void {
    this.primaryButtonClick.emit();
  }

  onSecondaryClickEmit(): void {
    this.secondaryButtonClick.emit();
  }
}
